import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
} from '@backstage/theme';

export const pocteo = createUnifiedTheme({
    ...createBaseThemeOptions({
        palette: {
            ...palettes.light,
            primary: {
                main: '#0a1263',
            },
            secondary: {
                main: '#565a6e',
            },
            error: {
                main: '#b9112f',
            },
            warning: {
                main: '#8f5e15',
            },
            info: {
                main: '#071498',
            },
            success: {
                main: '#5d9b14',
            },
            background: {
                default: '#e5e7eb',
                paper: '#f2f2f2',
            },
            banner: {
                info: '#34548a',
                error: '#c0163b',
                text: '#092db4',
                link: '#565a6e',
            },
            errorBackground: '#9a0612',
            warningBackground: '#cb841e',
            infoBackground: '#0c2077',
            navigation: {
                background: '#0a1263',
                indicator: '#d4dee5',
                color: '#9d959a',
                selectedColor: '#ffffff',
                navItem: {
                    hoverBackground: '#121B73',
                }
            },
            linkHover: '#000'
        },
    }),
    components: {
        // Target the Backstage Sidebar component
        BackstageSidebar: {
            styleOverrides: {
                drawer: {
                    background: 'linear-gradient(180deg, hsl(237, 53%, 8%), hsl(242, 83%, 16%)) !important',
                },
            },
        },
        BackstageSidebarItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        // This is the bg-white/10 equivalent
                        backgroundColor: 'rgba(255, 255, 255, 0.1) !important',
                    },
                },
            },
        },
        BackstageHeader: {
            styleOverrides: {
                header: {
                    // This creates a very fine 1px soft shadow
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05) !important',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05) !important',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    // Flat Light Grey Background
                    backgroundColor: '#eeeeee !important',

                    '& *': {
                        color: '#000000 !important',
                        fontWeight: 700,
                    },
                    padding: '16px 24px',
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#000000 !important',
                },
            },
        },
    },
    typography: {
        htmlFontSize: 18,
        fontFamily: 'Space Grotesk, sans-serif',
        h1: {
            fontSize: 30,
            fontWeight: 400,
            marginBottom: 10,
        },
        h2: {
            fontSize: 30,
            fontWeight: 400,
            marginBottom: 8,
        },
        h3: {
            fontSize: 22,
            fontWeight: 400,
            marginBottom: 6,
        },
        h4: {
            fontWeight: 400,
            fontSize: 18,
            marginBottom: 6,
        },
        h5: {
            fontWeight: 400,
            fontSize: 16,
            marginBottom: 4,
        },
        h6: {
            fontWeight: 400,
            fontSize: 14,
            marginBottom: 2,
        },
    },
    defaultPageTheme: 'home',
    fontFamily: 'Space Grotesk, sans-serif',
    /* below drives the header colors */
    pageTheme: {
        home: genPageTheme({
            colors: ['#fff', '#fff'],
            shape: shapes.round,
            options: { fontColor: '#202947'}}),
        documentation: genPageTheme({
            colors: ['#fff', '#fff'],
            shape: shapes.round,
            options: { fontColor: '#202947' }}),
        tool: genPageTheme({
            colors: ['#fff', '#fff'],
            shape: shapes.round,
            options: { fontColor: '#202947' }
        }),
        service: genPageTheme({
            colors: ['#0a1263', '#0a1263'],
            shape: shapes.round,
            options: { fontColor: '#fff' }
        }),
        action: genPageTheme({
            colors: ['#0a1263', '#0a1263'],
            shape: shapes.round,
            options: { fontColor: '#fff' }
        }),
        website: genPageTheme({
            colors: ['#fff', '#fff'],
            shape: shapes.round,
            options: { fontColor: '#202947' }
        }),
        library: genPageTheme({
            colors: ['#fff', '#fff'],
            shape: shapes.round,
            options: { fontColor: '#202947' }
        }),
        other: genPageTheme({ colors: ['#fff', '#fff'], shape: shapes.round, options: { fontColor: '#202947' } }),
        app: genPageTheme({ colors: ['#fff', '#fff'], shape: shapes.round, options: { fontColor: '#202947' } }),
        apis: genPageTheme({ colors: ['#fff', '#fff'], shape: shapes.round, options: { fontColor: '#202947' } }),
    },
});
